module.exports = __webpack_public_path__ + "img/sb2.d1fb2c02.png";